import React from "react";

const DocRequiredField = (props) => {
  let requiredField = null;
  if(props.valid === false || props.valid === null){
    requiredField = props.message;
  }

  return(
    <div className='required_gray'>
      <div>
        {requiredField}
      </div>
    </div>
  )}

export default DocRequiredField



// WEBPACK FOOTER //
// ./src/components/DocRequiredField.js